import _ from 'underscore';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import {
  recommendationConfigs,
  withAdsAutoApply,
  RECOMMENDATION_TYPES,
  withImgAutoRetrieve,
} from '@bingads-webui-campaign/recommendation-core';
import { FeedbackModal } from './feedback-modal';
import rejectFeedbackTemplate from './reject-feedback-template.pug';
import autoApplyFeedbackTemplate from './apply-feedback-template.pug';

class FeedbackView extends React.PureComponent {
  static propTypes = {
    el: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired,
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    i18n: PropTypes.objectOf(PropTypes.any).isRequired,
    newI18n: PropTypes.objectOf(PropTypes.any),
    isReject: PropTypes.bool.isRequired,
    campaignAutoApplyStatus: PropTypes.shape({
      [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: PropTypes.string,
    }),
    cid: PropTypes.string,
    aid: PropTypes.string,
    odata: PropTypes.PropTypes.shape({
      patch: PropTypes.func.isRequired,
    }),
    onAutoApplyCancel: PropTypes.func,
    isFromSummary: PropTypes.bool,
    isFromAutoApplyDialog: PropTypes.bool,
    recommendationsCount: PropTypes.number,
    readOnly: PropTypes.bool,
    isDismissAll: PropTypes.bool,
    recommendationTypesAvailable: PropTypes.arrayOf(PropTypes.string),
    showApplyConfirmModal: PropTypes.func,
    isCrossPageApplyAll: PropTypes.bool,
    isFromImgExtV2: PropTypes.bool,
    allowCrawlImagesFromLandingPage: PropTypes.bool,
    opportunities: PropTypes.arrayOf(PropTypes.any),
  }

  static defaultProps = {
    campaignAutoApplyStatus: {},
    cid: null,
    aid: null,
    odata: null,
    onAutoApplyCancel: null,
    isFromSummary: false,
    isFromAutoApplyDialog: false,
    recommendationsCount: 0,
    readOnly: false,
    isDismissAll: false,
    recommendationTypesAvailable: [],
    showApplyConfirmModal: _.noop,
    isCrossPageApplyAll: false,
    isFromImgExtV2: false,
    allowCrawlImagesFromLandingPage: false,
    opportunities: [],
    newI18n: {
      getString: _.noop,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: true,
    };
    ReactModal.setAppElement(props.el);
  }

  handleFeedbackCancel = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  callback = (opportunities) => {
    this.setState({
      isModalOpen: false,
    });
    if (!_.isUndefined(opportunities)) {
      this.props.callback(opportunities);
    } else {
      this.props.callback();
    }
  }

  render() {
    const { isModalOpen } = this.state;
    const {
      data: { type },
      i18n,
      newI18n,
      campaignAutoApplyStatus,
      isReject,
      cid,
      aid,
      odata,
      onAutoApplyCancel,
      isFromSummary,
      isFromAutoApplyDialog,
      showApplyConfirmModal,
      isCrossPageApplyAll,
      isFromImgExtV2,
      allowCrawlImagesFromLandingPage,
      opportunities,
    } = this.props;
    const titleConfig = recommendationConfigs[type].summaryTitle;
    const recommendationDescription = i18n.getString(titleConfig);
    let isApplyFeedBackFormShow = true;

    // If it's apply and adsByBingAutoApply is true (opt-in), it doesn't show the feedback form.
    if (isModalOpen && !isReject && (campaignAutoApplyStatus[type] === true
      || (isFromImgExtV2 && allowCrawlImagesFromLandingPage === 'true'))) {
      // If users apply all from summary page, it shows a confirmation dialog.
      if ((isFromSummary && isFromAutoApplyDialog) || isCrossPageApplyAll) {
        showApplyConfirmModal();
        return null;
      }
      isApplyFeedBackFormShow = false;
    }

    return (
      <FeedbackModal
        isOpen={isModalOpen}
        onCancel={this.handleFeedbackCancel}
        callback={this.callback}
        recommendationDescription={recommendationDescription}
        i18n={i18n}
        newI18n={newI18n}
        campaignAutoApplyStatus={campaignAutoApplyStatus}
        isApplyFeedBackFormShow={isApplyFeedBackFormShow}
        cid={cid}
        aid={aid}
        odata={odata}
        onAutoApplyCancel={onAutoApplyCancel}
        isFromSummary={isFromSummary}
        isFromAutoApplyDialog={isFromAutoApplyDialog}
        isFromImgExtV2={isFromImgExtV2}
        opportunities={opportunities}
        {..._.pick(this.props, 'dataService', 'el', 'data', 'context', 'guid', 'isReject', 'view', 'readOnly', 'permissions', 'viewDetails', 'isDismissAll', 'recommendationTypesAvailable', 'useCallbackAsSubmit', 'useNavigateModal', 'newI18n')}
      />
    );
  }
}

export function showRejectFeedbackPopup(options) {
  // when InProductFeedbackLoop is on, this function would show dismiss all popup.
  const container = document.querySelector('.recommendation-reject-feedback-popup');
  if (container !== null) {
    ReactDOM.unmountComponentAtNode(container);
  } else {
    $('body').append(rejectFeedbackTemplate());
  }
  const feedbackOptions = _.extend({}, options, { isReject: !options.isDismissAll });
  ReactDOM.render(
    (
      <FeedbackView {...feedbackOptions} />
    ), document.querySelector('.recommendation-reject-feedback-popup')
  );
}

export function showApplyFeedbackPopup(options) {
  const container = document.querySelector('.recommendation-apply-feedback-popup');
  if (container !== null) {
    ReactDOM.unmountComponentAtNode(container);
  } else {
    $('body').append(autoApplyFeedbackTemplate());
  }
  const feedbackOptions = _.extend({}, options, { isReject: false });
  if (options.isFromImgExtV2) {
    const ImgAutoFeedbackView = withImgAutoRetrieve(FeedbackView);
    ReactDOM.render(
      (
        <ImgAutoFeedbackView {...feedbackOptions} />
      ), document.querySelector('.recommendation-apply-feedback-popup')
    );
  } else {
    const AdsAutoFeedbackView = withAdsAutoApply(FeedbackView);
    ReactDOM.render(
      (
        <AdsAutoFeedbackView {...feedbackOptions} />
      ), document.querySelector('.recommendation-apply-feedback-popup')
    );
  }
}

